import { FC } from "react";
import { createPortal } from "react-dom";
import { AberturaCaixaForm } from "./AberturaCaixaForm";

interface Props {
  show: boolean;
  onClose: () => void;
  onOpened: () => void;
}

export const AbrirCaixaModal: FC<Props> = ({ show, onClose, onOpened }) => {
  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" role="dialog" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title fw-bold">Abrir Caixa</h3>
              <button
                type="button"
                className="btn-close"
                aria-label="Fechar"
                onClick={onClose}
              />
            </div>
            <div className="modal-body">
              <p className="text-muted fs-7 mb-5">
                Defina o operador e o fundo de caixa inicial
              </p>
              <AberturaCaixaForm
                onSuccess={() => {
                  onOpened();
                  onClose();
                }}
                onCancel={onClose}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};
